export const online_list_main_table_settings = {
  namespaced: true,
  state: {
    groupingType: 'platformType',
    fixedColumnWidth: null,
    fixedRowHeight: null,
  },
  getters: {
    groupingType: state => state.groupingType,
    fixedColumnWidth: state => state.fixedColumnWidth,
    fixedRowHeight: state => state.fixedRowHeight,
  },
  actions: {
    changeGrouping({ commit }, payload) {
      commit('changeGrouping', payload);
    },
    changeAllColumnWidths({ commit }, payload) {
      commit('changeAllColumnWidths', payload);
    },
    changeAllRowHeights({ commit }, payload) {
      commit('changeAllRowHeights', payload);
    },
  },
  mutations: {
    changeGrouping(state, payload) {
      state.groupingType = payload;
    },
    changeAllColumnWidths(state, payload) {
      state.fixedColumnWidth = payload;
    },
    changeAllRowHeights(state, payload) {
      state.fixedRowHeight = payload;
    },
  }
}